import { Router, watchBusy } from "@frui.ts/screens/dist";
import { attachAutomaticValidator } from "@frui.ts/validation/dist";
import { Modules, newNavigationName } from "config";
import { computed, observable } from "mobx";
import RoleRepository from "repositories/roleRepository";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import Role, { RoleValidationRules } from "entities/role";
import PermissionType from "entities/permissionType";
import PermissionArea from "../../../entities/permissionArea";
import EventBus from "../../../services/eventBus";
import OptionsService from "services/optionsService";
import CreateViewModel from "../../createViewModel";

@Router.registerRoute({ route: newNavigationName, name: Router.Self })
export default class RoleCreateViewModel extends CreateViewModel<Role> {
  readonly modelName = "role";
  @observable private permissionAreas: PermissionArea[] = [];

  constructor(
    protected repository: RoleRepository,
    protected localizationService: LocalizationService,
    protected notificationService: NotificationService,
    protected eventBus: EventBus,
    private optionsService: OptionsService
  ) {
    super();
    this.navigationName = newNavigationName;
  }

  @watchBusy
  async onInitialize(): Promise<void> {
    return super.onInitialize();
  }

  @computed
  get permissionAreaOptions() {
    return this.optionsService.entityOptions(PermissionArea);
  }

  @computed
  get permissionTypeOptions() {
    return this.optionsService.internalEnumOptions(PermissionType);
  }

  protected loadDetail(): Promise<Role> | Role {
    const item = new Role();
    attachAutomaticValidator(item, RoleValidationRules, false);
    return item;
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.users, `role.${code}`, size);
  }
}
